import React from 'react';

import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { reduxForm, InjectedFormProps } from 'redux-form';
import { ThunkDispatch } from 'redux-thunk';

import { loadJobDetails } from '../../action/job/load-job-details';
import { loadLabels } from '../../action/job/load-labels';
import { jobDetailsSelector, jobLabelsSelector, jobSelector } from '../../reducers/job-selectors';

import { JobFieldHighQualityCandidateSettings } from '../../job/fields/job-field-high-quality-candidate-settings';
import { JobFieldOtherApplicantRequirements } from '../../job/fields/job-field-minimum-age';

import { JobFlowButtons } from './job-flow-buttons';

const FORM_NAME = 'jobFlowHqcSettings';

const mapStateToProps = (state: any, ownProps: InputProps) => {
  const jobDetails = ownProps.jobId ? jobDetailsSelector(state, ownProps.jobId) : undefined;
  const job = ownProps.jobId ? jobSelector(state, ownProps.jobId) : undefined;
  const jobLabels = ownProps.jobId ? jobLabelsSelector(state, ownProps.jobId) : undefined;

  return {
    jobDetails,
    jobLabels,
    job,
    // See applicant-requirements-tab for the initial value here
    initialValues:
      job && jobLabels
        ? Object.assign(job, {
            JobLabelSettings: jobLabels.filter((l) => l.hasCustomSettings),
          })
        : [],
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<any, any, AnyAction>,
  ownProps: InputProps,
) => ({
  actions: {
    loadJobDetails: () => (ownProps.jobId ? dispatch(loadJobDetails(ownProps.jobId)) : undefined),
    loadJobLabels: () => (ownProps.jobId ? dispatch(loadLabels(ownProps.jobId)) : undefined),
  },
});

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type JobFlowApplicantFiltersComponentProps = InputProps & StateProps & DispatchProps;
type JobFlowApplicantFiltersFields = Partial<Job>;
type Props = InjectedFormProps<
  JobFlowApplicantFiltersFields,
  JobFlowApplicantFiltersComponentProps
> &
  JobFlowApplicantFiltersComponentProps;

interface InputProps extends JobFlowStep {
  jobId?: number;
}

class JobFlowApplicantFiltersComponent extends React.PureComponent<Props> {
  componentDidMount() {
    this.props.actions.loadJobDetails();
    this.props.actions.loadJobLabels();
  }

  componentDidUpdate(prevProps: Props) {
    this.props.actions.loadJobDetails();
    if (prevProps.dirty !== this.props.dirty) {
      this.props.onDirty(this.props.dirty);
    }
  }

  render() {
    const {
      onNext,
      onPrev,
      onSkip,
      jobId,
      job,
      jobDetails,
      jobLabels,
      handleSubmit,
      saving,
      editing,
    } = this.props;

    if (!jobDetails || !jobId || !jobLabels) {
      return null;
    }

    return (
      <form onSubmit={handleSubmit(onNext)}>
        <JobFieldHighQualityCandidateSettings jobId={jobId} jobDetails={jobDetails} isEditing />
        {job && <JobFieldOtherApplicantRequirements job={job} jobDetails={jobDetails} isEditing />}
        <JobFlowButtons
          disabled={false}
          onPrev={onPrev}
          onSkip={onSkip}
          editing={editing}
          saving={saving}
        />
      </form>
    );
  }
}

export const JobFlowApplicantFilters = connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  reduxForm<JobFlowApplicantFiltersFields, JobFlowApplicantFiltersComponentProps>({
    form: FORM_NAME,
    enableReinitialize: true,
  })(JobFlowApplicantFiltersComponent),
);
